export enum EmpresaStatusEnum {
    ATIVADA = 'ATIVADA',
    DESATIVADA = 'DESATIVADA'
}
